const getToken = (name) => {
    const metaName = name || 'csrf-token';
    const metas = [].slice.call(document.getElementsByTagName('meta'));
    return metas.reduce((val, meta) => (
        meta.getAttribute('name') === metaName ? meta.getAttribute('content') : val
    ), null);
};

export default getToken;



// WEBPACK FOOTER //
// ./utils/getXcsrfToken.js